// src/components/Common/ErrorMessage.js
import React from 'react';

const ErrorMessage = ({ message, type = 'error' }) => {
  const bgColor = type === 'warning' ? 'bg-yellow-100 border-yellow-400' : 'bg-red-100 border-red-400';
  const textColor = type === 'warning' ? 'text-yellow-700' : 'text-red-700';
  
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className={`border ${bgColor} ${textColor} px-4 py-3 rounded max-w-md`}>
        {message}
      </div>
    </div>
  );
};

export default ErrorMessage;